var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreferencesIconsReport = function SvgPreferencesIconsReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "preferences_icons_Report")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "preferences_icons_Report",
    transform: "translate(0.718931, 0.005048)",
    fill: "#63758D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2210692,2.16495177 L10.2210692,2.16495177 L10.2210692,1.67495177 C10.2324634,1.40795646 10.027821,1.18107028 9.7610692,1.16495177 L8.1610692,1.16495177 C7.96064323,0.720958044 7.60506293,0.365377742 7.1610692,0.164951769 C6.69574865,-0.0549839231 6.15638976,-0.0549839231 5.6910692,0.164951769 C5.23443941,0.382354321 4.8771272,0.764678381 4.6910692,1.23495177 L3.1710692,1.23495177 C2.90431742,1.25107028 2.69967498,1.47795646 2.7110692,1.74495177 L2.7110692,2.23495177 L0.711069204,2.23495177 C0.333283948,2.26757574 0.0336931715,2.56716651 0.00106920414,2.94495177 L0.00106920414,17.1349518 C-0.00978974541,17.3408971 0.062419114,17.5425911 0.201519201,17.6948493 C0.340619288,17.8471075 0.534983423,17.9372029 0.741069204,17.9449611 L8.6510692,17.9449611 C8.79064624,17.9458381 8.92307603,17.8833018 9.0110692,17.7749518 L12.8710692,13.5149518 C12.9255486,13.4425768 12.9569163,13.3554443 12.9610699,13.2649518 L12.9610699,2.94495177 C12.9616161,2.52931917 12.6361553,2.18626592 12.2210692,2.16495177 Z M9.0710692,13.7549518 L10.8510692,13.7549518 L9.0710692,15.7549518 L9.0710692,13.7549518 Z M8.6610692,12.5849518 L8.5410692,12.5849518 C8.39251556,12.5901624 8.25212837,12.6542208 8.15083892,12.7630132 C8.04954946,12.8718056 7.9956691,13.0164049 8.0010692,13.1649518 L8.0010692,16.7049518 L1.4810692,16.7049518 C1.29013831,16.6890793 1.14508866,16.5264479 1.1510692,16.3349518 L1.1510692,3.78495177 C1.14561059,3.69208826 1.17734468,3.60087191 1.2392627,3.53144867 C1.30118073,3.46202544 1.38818837,3.42010712 1.4810692,3.41495177 L2.7110692,3.41495177 L2.7110692,3.94495177 C2.7110692,4.37021103 3.05580995,4.71495177 3.4810692,4.71495177 L9.5810692,4.71495177 C9.97481363,4.67382652 10.2732111,4.34083227 10.2710692,3.94495177 L10.2710692,3.41495177 L11.4810692,3.41495177 C11.57395,3.42010712 11.6609577,3.46202544 11.7228757,3.53144867 C11.7847937,3.60087191 11.8165278,3.69208826 11.8110692,3.78495177 L11.8110692,12.5849518 L8.6610692,12.5849518 Z M3.8310692,3.47495177 L3.8310692,2.40495177 L5.4810692,2.40495177 C5.58221895,2.40509196 5.66574563,2.32596143 5.6710692,2.22495177 L5.7010692,1.94495177 C5.73666857,1.71822007 5.85848065,1.51400571 6.0410692,1.37495177 C6.20973556,1.248452 6.42485725,1.20105231 6.6310692,1.24495177 C6.96442131,1.32755751 7.21391261,1.60477006 7.2610692,1.94495177 L7.3210692,2.26495177 C7.32639278,2.36596143 7.40991945,2.44509196 7.5110692,2.44495177 L9.1310692,2.44495177 L9.1310692,3.47495177 L3.8310692,3.47495177 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.0510692,
    y: 5.95495177,
    width: 4.55,
    height: 1,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.0510692,
    y: 7.94495177,
    width: 8.86,
    height: 1,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.0510692,
    y: 9.93495177,
    width: 8.86,
    height: 1,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.0510692,
    y: 11.9249518,
    width: 4.55,
    height: 1,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.0510692,
    y: 13.9149518,
    width: 4.55,
    height: 1,
    rx: 0.42
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreferencesIconsReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preferences_icons_Report.55699d3d.svg";
export { ForwardRef as ReactComponent };